<template>
    <div class="componente" :style="{width: width, height:heigth, position: position, top:top, left:left }">
        
    </div>
</template>
<script>
export default {
    props:{
        heigth: String,
        width: String,
        position: String,
        top:String,
        left: String,
        titulo: String,
    }
    
}
</script>
<style>
.componente{
    position: absolute;
}
    
</style>